export default {"src":"/_next/static/media/anarock_logo.4c46ca7f.svg","height":149,"width":533,"blurWidth":0,"blurHeight":0};